export default __webpack_public_path__ + "1bf8263be2ca0d7e3c2a0b0e23e52833.png";